<template>
    <Layout>
        <PageHeader :title="title" :items="items" />

        <div class="row">
        <div class="col-12">
            <div class="card">
            <div class="card-body">
                <b-button @click="addCategoryModal" variant="primary" class="btn btn-success btn-sm"> <i class="mdi mdi-plus mr-1"></i> {{ $t('button.add.text') }}</b-button>
                <b-modal
                    id="modal-add"
                    centered
                    :title="$t('button.add.text')"
                    title-class="font-18"
                    :ok-title="$t('button.save.text')"
                    :cancel-title="$t('button.cancel.text')"
                    @ok="addCategory"
                >
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label for="validationCustom01">{{ $t('form.category-profile.label.category-name') }}</label>
                                <input
                                id="validationCustom01"
                                type="text"
                                class="form-control"
                                :placeholder="$t('form.category-profile.placeholder.category-name')"
                                v-model="form.category_name"
                                :class="{ 'is-invalid': submitted && $v.form.category_name.$error }"
                                />
                                <div v-if="submitted && $v.form.category_name.$error" class="invalid-feedback">
                                    <span v-if="!$v.form.category_name.required">{{ $t('form.error.text') }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label for="validationCustom02">{{ $t('form.category-profile.label.badge-color') }}</label>
                                <select 
                                class="custom-select" 
                                v-model="form.badge_color" 
                                :class="{ 'is-invalid': submitted && $v.form.badge_color.$error }">
                                    <option selected>{{ $t('form.category-profile.placeholder.badge-color') }}</option>
                                    <option value="blue">Blue</option>
                                    <option value="indigo">Indigo</option>
                                    <option value="purple">Purple</option>
                                    <option value="pink">Pink</option>
                                    <option value="red">Red</option>
                                    <option value="orange">Orange</option>
                                    <option value="yellow">Yellow</option>
                                    <option value="green">Green</option>
                                    <option value="teal">teal</option>
                                    <option value="cyan">Cyan</option>
                                </select>
                                <div v-if="submitted && $v.form.badge_color.$error" class="invalid-feedback">
                                    <span v-if="!$v.form.badge_color.required">{{ $t('form.error.text') }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-modal>
                <div class="row mt-4">
                <div class="col-sm-12 col-md-6">
                    <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                        Show&nbsp;&nbsp;
                        <b-form-select v-model="perPage" size="sm" :options="pageOptions" class="mx-1"></b-form-select>&nbsp;&nbsp;entries
                    </label>
                    </div>
                </div>
                <!-- Search -->
                <div class="col-sm-12 col-md-6">
                    <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                    <label class="d-inline-flex align-items-center">
                        Search:
                        <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ml-2"
                        ></b-form-input>
                    </label>
                    </div>
                </div>
                <!-- End search -->
                </div>
                <!-- Table -->
                <div class="table-responsive mb-0">
                <b-table
                    :items="tableData"
                    :fields="fields"
                    bordered striped
                    responsive="sm"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    @filtered="onFiltered"
                >
                    <template #cell(badge_color)="row">  
                    <span class="badge p-1 px-1 text-white rounded" :style="'background-color: var(--'+row.item.badge_color+')'"> {{row.item.badge_color}}</span>
                    </template>

                    <template #cell(actions)="row">
                        <b-button class="mr-1 btn-sm" variant="info" @click="editCategory(row.item.id_category, row.item.category_name, row.item.badge_color)"> 
                             <i class="bx bx-pencil"></i>
                        </b-button>
                        <b-modal
                            :id="'modal-edit'+row.item.id_category"
                            centered
                            :title="$t('button.update.text')"
                            title-class="font-18"
                            :ok-title="$t('button.update.text')"
                            :cancel-title="$t('button.cancel.text')"
                            @ok="updateCategory($event, row.item.id_category)"
                        >
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="validationCustom01">{{ $t('form.category-profile.label.category-name') }}</label>
                                        <input
                                        id="validationCustom01"
                                        type="text"
                                        class="form-control"
                                        :placeholder="$t('form.category-profile.placeholder.category-name')"
                                        v-model="form.category_name"
                                        :class="{ 'is-invalid': submitted && $v.form.category_name.$error }"
                                        />
                                        <div v-if="submitted && $v.form.category_name.$error" class="invalid-feedback">
                                            <span v-if="!$v.form.category_name.required">{{ $t('form.error.text') }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="validationCustom02">{{ $t('form.category-profile.label.badge-color') }}</label>
                                        <select 
                                        class="custom-select" 
                                        v-model="form.badge_color" 
                                        :class="{ 'is-invalid': submitted && $v.form.badge_color.$error }">
                                            <option selected>{{ $t('form.category-profile.placeholder.badge-color') }}</option>
                                            <option value="blue">Blue</option>
                                            <option value="indigo">Indigo</option>
                                            <option value="purple">Purple</option>
                                            <option value="pink">Pink</option>
                                            <option value="red">Red</option>
                                            <option value="orange">Orange</option>
                                            <option value="yellow">Yellow</option>
                                            <option value="green">Green</option>
                                            <option value="teal">Teal</option>
                                            <option value="cyan">Cyan</option>
                                        </select>
                                        <div v-if="submitted && $v.form.badge_color.$error" class="invalid-feedback">
                                            <span v-if="!$v.form.badge_color.required">{{ $t('form.error.text') }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </b-modal>

                        <b-button class="mr-2 btn-sm" variant="danger" @click="deleteCategory(row.item.id_category)">
                        <i class="bx bx-trash"></i>
                        </b-button>
                    </template>
                </b-table>
                </div>
                 <div class="row" v-if="rows > 10">
                <div class="col-2 col-xl-1">
                    <!-- <div v-if="selected[0]">
                      <b-button class="btn btn-sm" variant="danger" @click="bulkAction()">Bulk Delete : {{selected.length}} Rows Data</b-button>
                    </div> -->
                    <label class="d-inline-flex align-items-center">
                      Page
                      <b-form-input
                        v-model="currentPage"
                        placeholder="Page"
                        class="form-control w-10 form-control ml-2"
                      ></b-form-input>
                    </label>
                </div>
                <div class="col-10 col-xl-11 text-right" v-if="rows > 10">
                  <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                    </ul>
                  </div>
                </div>
            </div>
            </div>
            </div>
        </div>
        </div>
    </Layout>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { required } from "vuelidate/lib/validators";
import CategoryService from "@/helpers/category.service"

export default {
    page: {
        meta: [{ name: "description", content: appConfig.description }]
    },
    components: { Layout, PageHeader },
    data() {
        return {
            tableData: [],
            title: this.$t('menuitems.category.text'),
            items: [
                {
                text: this.$t('menuitems.setting.text'),
                href: "#"
                },
                {
                text: this.$t('menuitems.category.text'),
                active: true
                }
            ],
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filter: null,
            filterOn: [],
            sortBy: "",
            sortDesc: false,
            fields: [
                { key: "no", class: 'text-center', thStyle: { width: "3%" }, label:'No'},
                { key: "category_name", sortable: true, label: this.$t('table.category-profile.th.category-name') },
                { key: "badge_color", sortable: true, label: this.$t('table.category-profile.th.badge-color') },
                { key: "total_profile", sortable: true, label: this.$t('table.category-profile.th.profile') },
                { key: 'actions', class: 'text-center', label: this.$t('table.category-profile.th.action') }
            ],
            form: {
                category_name: "",
                badge_color: this.$t('form.category-profile.placeholder.badge-color')
            },
            submitted: false,
        };
    },
    validations: {
        form: {
            category_name: { required },
            badge_color: { required }
        },
    },
    computed: {
        rows() {
        return this.tableData.length;
        }
    },
    methods: {
        getCategory(){
            CategoryService.list()
            .then(response => {
                this.tableData = []
                response.data.data.forEach((val, index) => {
                    const data = {
                    "no": index+1,
                    "id_category" : val.id_category,
                    "category_name" : val.category_name,
                    "badge_color" : val.badge_color,
                    "total_profile" : val.total_profile,
                    }
                    this.tableData.push(data);
                });
            })
            .catch(err => {
                console.log(err);
            });
        },

        addCategoryModal(){
            this.$bvModal.show('modal-add')
            this.form.category_name = "";
            this.form.badge_color = this.$t('form.category-profile.placeholder.badge-color');
        },

        addCategory(e) {
            this.submitted = true;
            this.$v.$touch();
            if (this.form.category_name == '' || this.form.badge_color == '') {
                e.preventDefault();
            }else{
                const data = {
                    'category_name' : this.form.category_name,
                    'badge_color' : this.form.badge_color,
                }

                CategoryService.create(data)
                .then( response => {
                    this.getCategory();
                    Vue.swal({
                        position: "top-end",
                        icon: "success",
                        title: response.data.message,
                        showConfirmButton: false,
                        timer: 1500
                    });
                    this.$v.$reset();
                })
                .catch(err => {
                    console.log(err);
                });
            }
        },
        editCategory(id, name, color){
            this.$bvModal.show('modal-edit'+id)
            this.form.category_name = name;
            this.form.badge_color = color;
        },
        updateCategory(e, id){
            this.submitted = true;
            this.$v.$touch();
            if (this.form.category_name == '' || this.form.badge_color == '') {
                e.preventDefault();
            }else{
                const data = {
                    'category_name' : this.form.category_name,
                    'badge_color' : this.form.badge_color,
                }

                CategoryService.update(id, data)
                .then( response => {
                    this.getCategory();
                    Vue.swal({
                        position: "top-end",
                        icon: "success",
                        title: response.data.message,
                        showConfirmButton: false,
                        timer: 1500
                    });
                    this.resetForm();
                    this.$v.$reset();
                })
                .catch(err => {
                    console.log(err);
                });
            }
        },
        deleteCategory(id){
            Swal.fire({
                title: this.$t('button.delete.modal.confirmText[0]'),
                text: this.$t('button.delete.modal.confirmText[1]'),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                cancelButtonText: this.$t('button.cancel.text'),
                confirmButtonText: this.$t('button.delete.text')
            }).then((result) => {
                if (result.isConfirmed) {
                    CategoryService.delete(id)
                    .then( response => {
                        this.getCategory();
                        Swal.fire({
                            position: "top-end",
                            icon: "success",
                            title: response.data.message,
                            showConfirmButton: false,
                            timer: 1500
                        });
                    })
                    .catch( err => {
                        console.log(err);
                    });
                }
            });
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        onDelete(id){
            console.log('delete data:', id);
        },
        onView(id){
            console.log('details data:', id);
        },
        resetForm(){
            setTimeout(()=>{
                this.form.category_name = '';
                this.form.badge_color = this.$t('form.category-profile.placeholder.badge-color');
            }, 2000)
        }
    },
    mounted() {
        this.totalRows = this.items.length;
        this.getCategory();
    },
};
</script>

<style scoped>
.badge{
    border-radius: 2%;
}
.btn{
    border-radius: 7%;
}
</style>